import { render, staticRenderFns } from "./chat-history-message.vue?vue&type=template&id=59485c14&scoped=true"
import script from "./chat-history-message.vue?vue&type=script&lang=js"
export * from "./chat-history-message.vue?vue&type=script&lang=js"
import style0 from "./chat-history-message.vue?vue&type=style&index=0&id=59485c14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59485c14",
  null
  
)

export default component.exports